import {combine} from 'effector';

import {fetchDeclarationsGrid} from 'api';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';

import {DeclarationPaginationContent, DeclarationsGridRawRow} from 'types/declarations';

const domain = rootDomain.createDomain('DeclarationsGridTableDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDeclarationsGridFx',
    handler: fetchDeclarationsGrid,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    tableStateCacheChanged,
    stateReset,
} = createGridTableModel({
    domain,
});

export const data$ = domain.createStore<DeclarationPaginationContent<
    DeclarationsGridRawRow
> | null>(null);

export const searchChanged = domain.createEvent<string>();
export const search$ = domain.createStore('').on(searchChanged, (_, value) => value);

export const tableState$ = combine({
    data: data$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    search: search$,
    dataLoading: fetchDataFx.pending,
});
